import { http } from "../http-common";
import { IPackageRequest, IPackageResponse } from "../types/Package";

const getPurchasedCourseList = () => {
        return http.get<any[]>(`/students/course/purchased`);
};

const getAll = () => {
        return http.get<IPackageResponse>(`/course`);
};

const getAllActive = () => {
        return http.get<IPackageResponse>(`/course/active`);
};

const create = (data: any) => {
        return http.post<any>(`/course`, data);
};

const get = (id: number) => {
        return http.get<IPackageResponse>(`/course/${id}`);
};

const update = (id: number, data: any) => {
    return http.patch<any>(`/course/${id}`, data);
};

const updateSortOrder = (id: number, sortOrder: number) => {
    return http.put<any>(`/course/update-sort-order`, { id, sortOrder });
};

const updateActiveStatus = (id: number, isActive: boolean) => {
    return http.patch<any>(`/course/${id}/active`, { isActive });
};

const addStudentForFree = (courseId: number, studentId: number) => {
    return http.post<any>(`/course/${courseId}/student/${studentId}`);
};

const remove = (id: number) => {
        return http.delete<IPackageRequest>(`/course/${id}`);
};

const CourseService = {
    create,
    getAll,
    getAllActive,
    get,
    update,
    updateSortOrder,
    updateActiveStatus,
    addStudentForFree,
    remove,
    getPurchasedCourseList,
};

export default CourseService;
